import KaraokeOrderFormView1PriceBar from './KaraokeOrderFormView1PriceBar';
import KaraokeOrderFormView1WithOptionView from './KaraokeOrderFormView1WithOptionView';
import KaraokeOrderFormView1WithoutOptionView from './KaraokeOrderFormView1WithoutOptionView';
import KaraokeOrderPriceInfo from './KaraokeOrderPriceInfo';
import CustomButton from '../../../common/components/CustomButton';
import CustomCheckbox from '../../../common/components/CustomCheckbox';
import CustomRadio from '../../../common/components/CustomRadio';
import CustomTextInput from '../../../common/components/CustomTextInput';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

type KaraokeOrderFormView1FormViewFieldName =
  'royalty_order'|'already_entrusted'|'onvocal'|'duet'|'intro_click'|'physical'|'coupon_code';

export default function KaraokeOrderFormView1FormView({
  getValue,
  setValue,
  getErrors,
  priceInfo,
  planAmount,
  onNext,
} : {
  getValue: (name: KaraokeOrderFormView1FormViewFieldName) => string,
  setValue: (name: KaraokeOrderFormView1FormViewFieldName, value: string) => void,
  getErrors: (name: KaraokeOrderFormView1FormViewFieldName) => FieldValidationErrorsType,
  priceInfo: KaraokeOrderPriceInfo,
  planAmount: number,
  onNext: () => void,
}) {
  const royaltyOrderOptions = [
    {
      value: 'with_royalty',
      view: (
        <KaraokeOrderFormView1WithOptionView
          title="印税あり"
          image="/img/karaoke_service/stylish/icon_01.png"
          amountWithTax={priceInfo.royaltyOptionAmount}
          amountWithoutTax={priceInfo.royaltyOptionAmountWithoutTax}
        >
          著作権管理をNexToneに委託して、放送とカラオケに関する著作権利用料を受け取れます
        </KaraokeOrderFormView1WithOptionView>
      ),
    },
    {
      value: 'without_royalty',
      view: (
        <KaraokeOrderFormView1WithoutOptionView />
      ),
    },
  ];

  const onvocalOptions = [
    {
      value: '1',
      view: (
        <KaraokeOrderFormView1WithOptionView
          title="本人歌唱"
          image="/img/karaoke_service/stylish/icon_02.png"
          amountWithTax={priceInfo.onvocalOptionAmount}
          amountWithoutTax={priceInfo.onvocalOptionAmountWithoutTax}
        >
          通常のカラオケに加えて、
          <br className="sp" />
          本人歌唱バージョンも配信します
        </KaraokeOrderFormView1WithOptionView>
      ),
    },
    {
      value: '0',
      view: (
        <KaraokeOrderFormView1WithoutOptionView />
      ),
    },
  ];

  const physicalOptions = [
    {
      value: '1',
      view: (
        <KaraokeOrderFormView1WithOptionView
          title="郵送"
          image="/img/karaoke_service/stylish/icon_03.png"
          amountWithTax={priceInfo.physicalOptionAmount}
          amountWithoutTax={priceInfo.physicalOptionAmountWithoutTax}
        >
          データアップロードは難しいので、CD、DVD、Blu-rayを郵送したい
        </KaraokeOrderFormView1WithOptionView>
      ),
    },
    {
      value: '0',
      view: (
        <KaraokeOrderFormView1WithoutOptionView />
      ),
    },
  ];

  const duetOptions = [
    {
      value: '1',
      view: (
        <KaraokeOrderFormView1WithOptionView
          title="デュエット"
          image="/img/karaoke_service/stylish/icon_04.png"
          amountWithTax={priceInfo.duetOptionAmount}
          amountWithoutTax={priceInfo.duetOptionAmountWithoutTax}
        >
          メインボーカルが複数いるので、パートの色分けをしたい
        </KaraokeOrderFormView1WithOptionView>
      ),
    },
    {
      value: '0',
      view: (
        <KaraokeOrderFormView1WithoutOptionView />
      ),
    },
  ];

  const introClickOptions = [
    {
      value: '1',
      view: (
        <KaraokeOrderFormView1WithOptionView
          title="冒頭カウント"
          image="/img/karaoke_service/stylish/icon_05.png"
          amountWithTax={priceInfo.introClickOptionAmount}
          amountWithoutTax={priceInfo.introClickOptionAmountWithoutTax}
        >
          イントロがなく歌から始まる曲の冒頭に、カウントとコード音を追加します
        </KaraokeOrderFormView1WithOptionView>
      ),
    },
    {
      value: '0',
      view: (
        <KaraokeOrderFormView1WithoutOptionView />
      ),
    },
  ];
  
  return (
    <>
      <form className="cake_ajax_form">
        <h2 className="fadein1 add_contents">選べるオプション</h2>
        <div className="form_frame fadein3">
          <dl>
            <dt />
            <dd>
              <CustomRadio
                value={getValue('royalty_order')}
                setValue={(value) => setValue('royalty_order', value)}
                options={royaltyOrderOptions}
                validationErrors={getErrors('royalty_order')}
              />
            </dd>
          </dl>
          <div className="form__body pc_mb35">
            <CustomCheckbox
              checked={getValue('already_entrusted') === '1'}
              setChecked={(checked) => setValue('already_entrusted', checked ? '1' : '0')}
            >
              申し込む曲はJASRAC/NexToneに著作権管理を委託している、
              または委託予定です（作詞作曲者がJASRAC会員である場合を含む）
            </CustomCheckbox>
          </div>

          <dl>
            <dt />
            <dd>
              <CustomRadio
                value={getValue('onvocal')}
                setValue={(value) => setValue('onvocal', value)}
                options={onvocalOptions}
                validationErrors={getErrors('onvocal')}
              />
            </dd>
          </dl>
          <dl>
            <dt />
            <dd>
              <CustomRadio
                value={getValue('physical')}
                setValue={(value) => setValue('physical', value)}
                options={physicalOptions}
                validationErrors={getErrors('physical')}
              />
            </dd>
          </dl>
          <dl>
            <dt />
            <dd>
              <CustomRadio
                value={getValue('duet')}
                setValue={(value) => setValue('duet', value)}
                options={duetOptions}
                validationErrors={getErrors('duet')}
              />
            </dd>
          </dl>
          <dl>
            <dt />
            <dd>
              <CustomRadio
                value={getValue('intro_click')}
                setValue={(value) => setValue('intro_click', value)}
                options={introClickOptions}
                validationErrors={getErrors('intro_click')}
              />
            </dd>
          </dl>

          <div className="form__body" style={{ marginBottom: '30px' }}>
            <dl>
              <dt>
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label>クーポンコード</label>
              </dt>
              <dd>
                <CustomTextInput
                  placeholder="お持ちの場合は入力してください"
                  value={getValue('coupon_code')}
                  setValue={(value) => setValue('coupon_code', value)}
                  validationErrors={getErrors('coupon_code')}
                />
              </dd>
            </dl>
          </div>

          <ul>
            <li className="bt">
              <CustomButton type="default" onClick={() => onNext()}>次へ</CustomButton>
            </li>
          </ul>

        </div>
      </form>
      <KaraokeOrderFormView1PriceBar
        planAmount={planAmount}
        onSubmit={() => onNext()}
      />
    </>
  );
}
